export const FILTER_BAR_MODULE = {
  FILTERS: [
    {
      index: 0,
      name: 'By Competition'
    },
    {
      index: 1,
      name: 'By Date'
    },
  ],
  ANALYTICS: {
    ACTION_TYPES: {
      toggleClick: 'toggleClick'
    },
    TOGGLE_TYPES: {
      live: 'Live',
      odds: 'Odds',
      byTime: 'By-Time',
    }
  }
}
